import React from "react"
import Typography from '@mui/material/Typography';
//import ArrowRightIcon from '@mui/icons-material/ArrowRight';

export const TextFTO = () => {

return(
<div>
    
<Typography variant="h6" >
<br />

FTO gene variants are associated in scientific literature with phenotype obesity/BMI. 

 FTO contains nine exons (depicted by blue rectangles) and the body mass index (BMI)-associated SNP identified in genome-wide association studies (depicted by a red ×) maps to intron 1. 
 IRX3 and RPGRIP1L have both been proposed to be the causal genes for obesity within the locus and to act on body weight through distinct mechanisms. HFD, high-fat diet. <br /><br /> 



 <Typography component="span" variant="h5" sx={{fontWeight: '600'}}>Summary: </Typography>
<br /><br />

FTO_variants = ['rs9939609', 'rs1558902', 'rs1121980', 'rs8050136', 'rs1421085', 'rs17817449' ] <br /> 
FTO_genes = ['FTO', 'RPGRIP1L', 'IRX3', 'IRX5', 'IRX6' ] <br /> <br /> 

<Typography component="span" variant="h5" sx={{fontWeight: '600'}}>FTO gene variants are associated in scientific literature with phenotype obesity/BMI: </Typography>
<br /><br />

SNPs: rs1558902 (A;A and A;T Higher BMI than normal), rs9939609 (A;A	obesity risk and 1.6x risk for T2D, A;T	1.3x risk for T2D; obesity risk, rs9939609 in linkage block with rs1121980, rs8050136, three FTO SNPs: rs1421085, rs17817449, and rs9939609, are in strong linkage disequilibrium
    <br /><br /> 
FTO rs9939609 is a SNP in the fat mass and obesity associated FTO gene, aka the "Fat Gene" (SNPedia) -- Obesity related. Raises T2D risk through obesity. The researchers identified 10 different FTO SNPs in the first intron of the gene that associated with both BMI and type-2 diabetes. 
Because they all correlated with each other, they chose to examine one of the SNPs (rs9939609) in detail.
<br /><br /> 
SNP was found in a linkage block in the FTO gene with rs1121980; see rs1121980 for the association of this block with early onset obesity since it showed the strongest association. Three FTO SNPs, rs1421085, rs17817449, and rs9939609, are in strong linkage disequilibrium
risk-allele A at rs9939609 was significantly associated with 0.45 kg/m(2) increase in BMI. 
<br /><br /> 
Similar results were observed for rs8050136. may confer a modest susceptibility to obesity in an ethnicity-specific manner, but may be unlikely to contribute to a clinically significant diabetes risk.
<br /><br />  

<Typography component="span" variant="h5" sx={{fontWeight: '600'}}>Aspects regarding precision nutrition: </Typography>
<br /><br />

protein intake has consistently been shown to influence measures of body weight and composition dependent on FTO genotype (rs9939609 or loci in strong linkage disequilibrium (LD)) 

<br /><br /> 
Recent evidence suggests that the fat mass and obesity-associated gene (FTO) genotype may interact with dietary intakes in relation to adiposity. --  
<br />  effect of FTO variant on weight loss in response to 2-year diet interventions. 
<br /><br />   FTO rs1558902 was genotyped in 742 obese adults who were randomly assigned to one of four diets differing in the proportions of fat, protein, and carbohydrate. Body composition and fat distribution were measured by dual-energy x-ray absorptiometry and computed tomography. 
<br /><br />   Carriers of the risk allele had a greater reduction in weight, body composition, and fat distribution in response to a high-protein diet, whereas an opposite genetic effect was observed on changes in fat distribution in response to a low-protein diet. 
<br /><br />   Our data suggest that a high-protein diet may be beneficial for weight loss and improvement of body composition and fat distribution in individuals with the risk allele of the FTO variant rs1558902
                                                                                <br /><br /> 

These findings suggest that high dietary protein intake may protect against the effects of risk variants in the FTO gene on BMI and waist circumference. - rs1558902 risk allele
<br /><br /> 

 
</Typography>

</div>
)
}